module.exports = __webpack_public_path__ + "img/u115.7d9198d2.png";